import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">{t('privacyPolicy.title')}</h1>
      <p className="text-sm text-gray-600 mb-8">{t('privacyPolicy.lastUpdated')}: January 17, 2025</p>
      
      <div className="prose prose-blue max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('privacyPolicy.introduction.title')}</h2>
          <p className="mb-4">{t('privacyPolicy.introduction.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('privacyPolicy.informationWeCollect.title')}</h2>
          <h3 className="text-xl font-semibold mb-2">{t('privacyPolicy.informationWeCollect.personalInfo')}</h3>
          <ul className="list-disc pl-6 mb-4">
            {t('privacyPolicy.informationWeCollect.personalInfoList', { returnObjects: true }).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <h3 className="text-xl font-semibold mb-2">{t('privacyPolicy.informationWeCollect.automaticInfo')}</h3>
          <ul className="list-disc pl-6 mb-4">
            {t('privacyPolicy.informationWeCollect.automaticInfoList', { returnObjects: true }).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('privacyPolicy.howWeUseInfo.title')}</h2>
          <ul className="list-disc pl-6 mb-4">
            {t('privacyPolicy.howWeUseInfo.purposes', { returnObjects: true }).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('privacyPolicy.dataProtection.title')}</h2>
          <p className="mb-4">{t('privacyPolicy.dataProtection.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('privacyPolicy.thirdPartyDisclosure.title')}</h2>
          <p className="mb-4">{t('privacyPolicy.thirdPartyDisclosure.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('privacyPolicy.contactUs.title')}</h2>
          <p className="mb-4">{t('privacyPolicy.contactUs.content')}</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
